import { ref } from 'vue'

import { defineStore } from 'pinia'

import { getFobsMasterData } from '@/services/api/fobs'
import type { FobsMasterData, ObservationPreset, SpottingType, SpreadType } from '@/types/Fobs'

export default defineStore('fobs', () => {
  const spreadTypes = ref<Array<SpreadType>>([])
  const spottingTypes = ref<Array<SpottingType>>([])
  const observationPresets = ref<Array<ObservationPreset>>([])
  const isDataRequested = ref(false)

  async function requestMasterData() {
    if (!isDataRequested.value) {
      const fobsMasterData: FobsMasterData = await getFobsMasterData()
      fobsMasterData.spottingTypes.forEach((element) => {
        spottingTypes.value.push(element)
      })
      fobsMasterData.spreadTypes.forEach((element) => {
        spreadTypes.value.push(element)
      })
      fobsMasterData.observationPresets.forEach((element) => {
        observationPresets.value.push(element)
      })
      isDataRequested.value = true
    }
  }

  function getSpreadsBasedOnSpot(spotId?: string) {
    if (spotId === undefined) return spreadTypes.value.map((x) => x.id)

    const spreads: Array<string> = []
    observationPresets.value.forEach((element) => {
      if (element.spottingType.id === spotId) spreads.push(element.spreadType.id)
    })
    return spreads
  }

  function getSpotsBasedOnSpread(spreadId?: string) {
    if (spreadId === undefined) return spottingTypes.value.map((x) => x.id)

    const spots: Array<string> = []
    observationPresets.value.forEach((element) => {
      if (element.spreadType.id === spreadId) spots.push(element.spottingType.id)
    })
    return spots
  }

  function getPreset(spreadId: string, spotId: string) {
    const presets: ObservationPreset[] = observationPresets.value.filter((v) => v.spreadType.id == spreadId && v.spottingType.id == spotId)
    if (presets.length) return presets[0]
  }

  return {
    getPreset,
    requestMasterData,
    getSpreadsBasedOnSpot,
    getSpotsBasedOnSpread,
    spreadTypes,
    spottingTypes,
    isDataRequested,
    observationPresets
  }
})
